import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ArrowLeftRight, CreditCard, UserRound, ShieldCheck } from 'lucide-react';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const tabs = [
    { label: 'Dashboard', icon: Home, route: '/dashboard' },
    { label: 'Transactions', icon: ArrowLeftRight, route: '/transactions' },
    { label: 'Accounts', icon: CreditCard, route: '/banks' },
    { label: 'Profile', icon: UserRound, route: '/user-profile' },
  ];

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-inner">
        {tabs.map(({ label, icon: Icon, route }) => {
          const active = path === route || (route !== '/' && path.startsWith(route));
          return (
            <button
              key={route}
              onClick={() => navigate(route)}
              className={`bottom-nav-btn ${active ? 'active' : ''}`}
            >
              <Icon size={20} strokeWidth={active ? 2.5 : 1.8} />
              <span className={`bottom-nav-label ${active ? 'font-semibold' : ''}`}>{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
